import React, { createContext, useContext } from 'react';
import { CashFlowContextValue } from './CashFlowContext.types';

const CashFlowContext = createContext<CashFlowContextValue | undefined>(undefined);

export const useCashFlowContext = () => {
  const context = useContext(CashFlowContext);
  if (!context) {
    throw new Error('useCashFlowContext must be used within a CashFlowContext.Provider');
  }
  return context;
};

export default CashFlowContext;
